import actions from './onlineSalesProcess.types'

const initialState = {
  loading: true,
  onlineSalesPartyAvailabilityData: [],
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
